import * as React from 'react';
import styles from './index.less';
import FLocalUpload from '@/components/FLocalUpload';
import FStorageSpace from '@/components/FStorageSpace';
import FResourceMarkdownEditor from '@/components/FResourceMarkdownEditor';
import FResourceCartoonEditor from '@/components/FResourceCartoonEditor';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FUtil } from '@freelog/tools-lib';
// import img from '@/assets/file-object.svg';
import FTooltip from '@/components/FTooltip';
import { Progress, Space } from 'antd';
import fResourceOptionEditor from '@/components/fResourceOptionEditor';
import FResourceOptions from '@/components/FResourceOptions';
import { connect } from 'dva';
import { ConnectState, ResourceVersionCreatorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import * as AHooks from 'ahooks';
import FCoverImage from '@/components/FCoverImage';
import FUploadCover from '@/components/FUploadCover';
import {
  ChangeAction,
  OnChange_CustomConfigurations_Action,
  OnChange_CustomProperties_Action,
  OnChange_DescriptionText_Action,
  OnChange_IsOpenCartoon_Action,
  OnChange_VersionInput_Action,
  OnClick_CreateVersionBtn_Action,
  OnClick_OpenCartoonBtn_Action,
  OnClose_CartoonEditor_Action,
  OnClose_MarkdownEditor_Action,
  OnDelete_ObjectFile_Action,
  OnMountPageAction,
  OnSucceed_ImportObject_Action,
  OnSucceed_UploadFile_Action,
  OnTrigger_SaveDraft_Action,
  OnUnmountPageAction,
} from '@/models/resourceVersionCreatorPage';
import FReleaseTip from '@/components/FReleaseTip';
import FVersionInput from '@/components/FVersionInput';
import FPrompt from '@/components/FPrompt';
// import FSkeletonNode from '@/components/FSkeletonNode';
import { history, useParams } from 'umi';
import FMicroApp_MarkdownEditorDrawer from '@/components/FMicroApp_MarkdownEditorDrawer';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import FMicroApp_CartoonEditorDrawer from '@/components/FMicroApp_CartoonEditorDrawer';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import { VersionDescriptionEditor } from '@/pages/resource/collectionSidebar/versionInfo/$id';
import FIcons from '@/components/FIcons';
import FTextBtn from '@/components/FButton/FTextBtn';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';
// import FFileTypeIcon from '@/components/FFileTypeIcon';
import FFileIcon from '@/components/FFileIcon';
// import { PropertyParser } from '@/utils/PropertyParser';

interface VersionCreatorProps {
  dispatch: Dispatch;
  resourceVersionCreatorPage: ResourceVersionCreatorPageModelState;
}

function VersionCreator({ dispatch, resourceVersionCreatorPage }: VersionCreatorProps) {
  const params = useParams();
  const id = params.id ?? '';

  const [$showMore, set$ShowMore, get$ShowMore] = FUtil.Hook.useGetState<boolean>(false);
  const [$versionInputHasError, set$versionInputHasError] = FUtil.Hook.useGetState<boolean>(false);
  const [isMarkdownEditorDirty, set_isMarkdownEditorDirty] = FUtil.Hook.useGetState<boolean>(false);

  const [$uploadingInfo, set$uploadingInfo, get$uploadingInfo] = FUtil.Hook.useGetState<null | {
    name: string;
    percent: number;
    cancelHandler: any;
  }>(null);

  // 视频类型资源上传封面：资源类型名称包含「视频」时展示上传入口
  const isVideoResource: boolean = (
    resourceVersionCreatorPage.resourceInfo?.resourceType || []
  ).some((t) => t.includes('视频'));

  AHooks.useMount(() => {
    dispatch<OnMountPageAction>({
      type: 'resourceVersionCreatorPage/onMountPage',
      payload: {
        resourceID: id,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountPageAction>({
      type: 'resourceVersionCreatorPage/onUnmountPage',
    });
  });

  AHooks.useDebounceEffect(
    () => {
      if (resourceVersionCreatorPage.dataIsDirty) {
        dispatch<OnTrigger_SaveDraft_Action>({
          type: 'resourceVersionCreatorPage/onTrigger_SaveDraft',
          payload: {
            showSuccessTip: false,
          },
        });
      }
    },
    [resourceVersionCreatorPage.dataIsDirty, resourceVersionCreatorPage.descriptionText],
    {
      wait: 300,
    },
  );

  async function onClick_EditMarkdownBtn() {
    await dispatch<OnTrigger_SaveDraft_Action>({
      type: 'resourceVersionCreatorPage/onTrigger_SaveDraft',
      payload: {
        showSuccessTip: false,
      },
    });
    dispatch<ChangeAction>({
      type: 'resourceVersionCreatorPage/change',
      payload: {
        isOpenMarkdown: true,
      },
    });
  }

  async function onClose_EditMarkdown() {
    await dispatch<ChangeAction>({
      type: 'resourceVersionCreatorPage/change',
      payload: {
        isOpenMarkdown: false,
        authReload: 0,
      },
    });
    await set_isMarkdownEditorDirty(false);
    await dispatch<OnClose_MarkdownEditor_Action>({
      type: 'resourceVersionCreatorPage/onClose_MarkdownEditor',
    });
  }

  const hasError: boolean =
    resourceVersionCreatorPage.versionInput === '' ||
    $versionInputHasError ||
    !resourceVersionCreatorPage.selectedFileInfo ||
    !resourceVersionCreatorPage.isCompleteAuthorization;

  return (
    <>
      <div
        className={styles.noSelectedFileInfo}
        style={{
          display: !resourceVersionCreatorPage.selectedFileInfo ? 'flex' : 'none',
        }}
      >
        <div style={{ height: 40 }} />
        <div style={{ display: 'flex', alignItems: 'center', width: 920 }}>
          <a
            href={FUtil.LinkTo.resourceVersionInfo({
              resourceID: resourceVersionCreatorPage.resourceInfo?.resourceID || '',
              version: resourceVersionCreatorPage.resourceInfo?.latestVersion || undefined,
            })}
            target={'_blank'}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div style={{ width: 36, height: 27, position: 'relative' }}>
              <FCoverImage
                src={resourceVersionCreatorPage.resourceInfo?.cover || ''}
                width={36}
                style={{ borderRadius: 4 }}
              />
              <img
                src={img_choiceLabel}
                alt={''}
                style={{
                  width: 12,
                  height: 12,
                  position: 'absolute',
                  top: 2,
                  left: 2,
                }}
              />
            </div>
            <div style={{ width: 10 }} />
            <FComponentsLib.FContentText
              text={
                resourceVersionCreatorPage.resourceInfo?.resourceTitle ||
                resourceVersionCreatorPage.resourceInfo?.resourceName ||
                ''
              }
              type={'highlight'}
              style={{
                maxWidth: 490,
              }}
              singleRow
            />
            <div style={{ width: 5 }} />
            <label
              style={{
                backgroundColor: '#E4E7EB',
                borderRadius: 4,
                fontSize: 12,
                color: '#666',
                padding: '0 5px',
                lineHeight: '18px',
                display: 'inline-block',
                maxWidth: 240,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {resourceVersionCreatorPage.resourceInfo?.resourceType.join('/')}
            </label>
            <div style={{ width: 10 }} />
            <FComponentsLib.FTitleText text={'/'} type={'h1'} />
          </a>

          <div style={{ width: 10 }} />
          <FComponentsLib.FTitleText
            text={
              // 新建版本
              FI18n.i18nNext.tAuto('create_new_version_newversion')
            }
            type={'h1'}
          />
        </div>
        <div style={{ height: 100 }} />
        {!!$uploadingInfo && (
          <div style={{ width: 920 }}>
            <div className={styles.fileInfo}>
              <div className={styles.card}>
                <FFileIcon mime={''} sha1={''} />
                <div style={{ width: 20 }} />
                <div>
                  <FComponentsLib.FContentText
                    type='highlight'
                    text={$uploadingInfo?.name || ''}
                    style={{ maxWidth: 600 }}
                    singleRow
                  />
                  <div style={{ height: 18 }} />
                  <div className={styles.info}>
                    <FComponentsLib.FContentText
                      className={styles.infoSize}
                      type='additional1'
                      text={FI18n.i18nNext.tAuto('createversion_object_fromlocal')}
                    />
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', width: 270 }}>
                <FComponentsLib.FContentText
                  text={`${$uploadingInfo?.percent > 99 ? 99 : $uploadingInfo?.percent || 0}%`}
                  type={'additional1'}
                  style={{ color: '#222' }}
                />
                <div style={{ width: 10 }} />
                <Progress
                  percent={$uploadingInfo?.percent > 99 ? 99 : $uploadingInfo?.percent || 0}
                  showInfo={false}
                  style={{ width: 140 }}
                />
                <div style={{ width: 20 }} />
                {/* {$uploadingInfo?.percent === 100 ? (
                  <FComponentsLib.FTextBtn style={{ fontSize: 12 }} type={'primary'}>
                    正在解析
                  </FComponentsLib.FTextBtn>
                ) : ( */}
                <FComponentsLib.FTextBtn
                  style={{ fontSize: 12 }}
                  type={'danger'}
                  onClick={() => {
                    const uploadingInfo = get$uploadingInfo();
                    uploadingInfo && uploadingInfo.cancelHandler();
                    set$uploadingInfo(null);
                  }}
                >
                  取消上传
                </FComponentsLib.FTextBtn>
              </div>
            </div>
          </div>
        )}

        {!$uploadingInfo && (
          <div className={styles.styles}>
            {resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes('localUpload') && (
              <FLocalUpload
                limitFileSize={resourceVersionCreatorPage.resourceTypeConfig.limitFileSize}
                style={{ width: '100%', flexGrow: 1 }}
                resourceTypeCode={resourceVersionCreatorPage.resourceInfo?.resourceTypeCode || ''}
                onSucceed={(value) => {
                  dispatch<OnSucceed_UploadFile_Action>({
                    type: 'resourceVersionCreatorPage/onSucceed_UploadFile',
                    payload: {
                      name: value.fileName,
                      sha1: value.sha1,
                    },
                  });
                }}
                onChange_uploadingInfo={(value) => {
                  set$uploadingInfo(value);
                }}
              />
            )}

            {resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes('storageSpace') && (
              <FStorageSpace
                style={{ width: '100%', flexGrow: 1 }}
                resourceTypeCode={resourceVersionCreatorPage.resourceInfo?.resourceTypeCode || ''}
                onSucceed={(value) => {
                  dispatch<OnSucceed_ImportObject_Action>({
                    type: 'resourceVersionCreatorPage/onSucceed_ImportObject',
                    payload: {
                      name: value.objectName,
                      sha1: value.sha1,
                      objID: value.objectID,
                    },
                  });
                }}
              />
            )}

            {resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes(
              'markdownEditor',
            ) && (
              <FResourceMarkdownEditor
                style={{ width: '100%', flexGrow: 1 }}
                onClickBtn={() => {
                  onClick_EditMarkdownBtn();
                }}
              />
            )}

            {resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes(
              'cartoonEditor',
            ) && (
              <FResourceCartoonEditor
                style={{ width: '100%', flexGrow: 1 }}
                onClickBtn={() => {
                  dispatch<OnClick_OpenCartoonBtn_Action>({
                    type: 'resourceVersionCreatorPage/onClick_OpenCartoonBtn',
                  });
                }}
              />
            )}
          </div>
        )}

        <div style={{ height: 100 }} />

        <FReleaseTip visible={resourceVersionCreatorPage.releaseTipVisible} />
      </div>
      <FPrompt
        watch={
          resourceVersionCreatorPage.dataIsDirty ||
          isMarkdownEditorDirty ||
          resourceVersionCreatorPage.isDirtyMarkdownEditor ||
          resourceVersionCreatorPage.isDirtyCartoonEditor
        }
        onOk={(locationHref) => {
          history.push(locationHref);
          dispatch<OnChange_IsOpenCartoon_Action>({
            type: 'resourceVersionCreatorPage/onChange_IsOpenCartoon',
            payload: {
              value: false,
            },
          });
        }}
      />

      <div
        className={styles.selectedFileInfo}
        style={{
          display: resourceVersionCreatorPage.selectedFileInfo ? 'flex' : 'none',
        }}
      >
        <div style={{ width: 920 }}>
          <div style={{ height: 40 }} />
          <div style={{ display: 'flex', alignItems: 'center', width: 920 }}>
            <a
              style={{ display: 'flex', alignItems: 'center' }}
              href={FUtil.LinkTo.resourceVersionInfo({
                resourceID: resourceVersionCreatorPage.resourceInfo?.resourceID || '',
                version: resourceVersionCreatorPage.resourceInfo?.latestVersion || undefined,
              })}
              target={'_blank'}
            >
              <div style={{ width: 36, height: 27, position: 'relative' }}>
                <FCoverImage
                  src={resourceVersionCreatorPage.resourceInfo?.cover || ''}
                  width={36}
                  style={{ borderRadius: 4 }}
                />
                <img
                  src={img_choiceLabel}
                  alt={''}
                  style={{
                    width: 12,
                    height: 12,
                    position: 'absolute',
                    top: 2,
                    left: 2,
                  }}
                />
              </div>
              <div style={{ width: 10 }} />
              <FComponentsLib.FContentText
                text={
                  resourceVersionCreatorPage.resourceInfo?.resourceTitle ||
                  resourceVersionCreatorPage.resourceInfo?.resourceName ||
                  ''
                }
                type={'highlight'}
              />
              <div style={{ width: 5 }} />
              <label
                style={{
                  backgroundColor: '#E4E7EB',
                  borderRadius: 4,
                  fontSize: 12,
                  color: '#666',
                  padding: '0 5px',
                  lineHeight: '18px',
                  display: 'inline-block',
                }}
              >
                {resourceVersionCreatorPage.resourceInfo?.resourceType.join('/')}
              </label>
              <div style={{ width: 10 }} />
              <FComponentsLib.FTitleText text={'/'} type={'h1'} />
            </a>

            <div style={{ width: 10 }} />
            <FComponentsLib.FTitleText
              text={
                // 新建版本
                FI18n.i18nNext.tAuto('create_new_version_newversion')
              }
              type={'h1'}
            />
          </div>
          <div style={{ height: 30 }} />
          <FVersionInput
            value={resourceVersionCreatorPage.versionInput}
            resourceLatestVersion={
              resourceVersionCreatorPage.resourceInfo?.latestVersion || '1.0.0'
            }
            onChange={(value) => {
              dispatch<OnChange_VersionInput_Action>({
                type: 'resourceVersionCreatorPage/onChange_VersionInput',
                payload: {
                  value: value,
                },
              });
            }}
            onChangeError={(hasError) => {
              set$versionInputHasError(hasError);
            }}
          />

          <div style={{ height: 30 }} />

          {/* 顶部资源卡片：与 sidebar/versionInfo 同结构（blockCard + baseInfo） */}
          <div className={styles.blockCard}>
            <div className={styles.baseInfo}>
              <div className={styles.baseInfoLeft}>
                <div
                  className={[
                    styles.baseInfoLeftIcon,
                    (() => {
                      if (resourceVersionCreatorPage.videoCover) {
                        return styles.baseInfoLeftIcon_withImage;
                      }
                      const mime =
                        resourceVersionCreatorPage.systemProperties.find(
                          (sp) => sp.key === 'mime',
                        )?.value || '';
                      const sha1 =
                        resourceVersionCreatorPage.selectedFileInfo?.sha1 || '';
                      const hasCover =
                        (mime?.startsWith('image/') || mime?.startsWith('video/')) &&
                        !!sha1;
                      return hasCover
                        ? styles.baseInfoLeftIcon_withImage
                        : styles.baseInfoLeftIcon_iconOnly;
                    })(),
                  ].join(' ')}
                >
                  {resourceVersionCreatorPage.videoCover ? (
                    <img src={resourceVersionCreatorPage.videoCover} alt='' />
                  ) : (
                    <FFileIcon
                      mime={
                        resourceVersionCreatorPage.systemProperties.find(
                          (sp) => sp.key === 'mime',
                        )?.value || ''
                      }
                      sha1={
                        resourceVersionCreatorPage.selectedFileInfo?.sha1 || ''
                      }
                    />
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <FComponentsLib.FContentText
                    type='highlight'
                    text={
                      resourceVersionCreatorPage.selectedFileInfo?.name || ''
                    }
                    style={{ maxWidth: 400, fontSize: 14, fontWeight: 600, color: '#222' }}
                    singleRow
                  />
                  {resourceVersionCreatorPage.selectedFileInfo?.from !==
                    '上个版本' && (
                    <FComponentsLib.FContentText
                      type='additional2'
                      style={{ maxWidth: 400, fontSize: 12, color: '#999' }}
                      text={(() => {
                        const from =
                          resourceVersionCreatorPage.selectedFileInfo?.from || '';
                        if (from === '本地上传') {
                          // 本地上传来源说明
                          return FI18n.i18nNext.tAuto('createversion_object_fromlocal');
                        }
                        if (from === '存储空间') {
                          // 存储空间来源说明
                          return FI18n.i18nNext.tAuto('createversion_object_fromstorage');
                        }
                        if (from.startsWith('最近编辑时间')) {
                          return `${
                            // 最近修改时间前缀
                            FI18n.i18nNext.tAuto('createversion_object_lastmodified')
                          } ${from.slice(6).trim()}`;
                        }
                        return from;
                      })()}
                      singleRow
                    />
                  )}
                </div>
              </div>
              <div className={styles.baseInfoRight}>
                {resourceVersionCreatorPage.resourceTypeConfig.isSupportEdit && (
                  <FTextBtn
                    type='primary'
                    size='default'
                    disabled={resourceVersionCreatorPage.systemPropertiesState === 'parsing'}
                    onClick={async () => {
                      if (
                        resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes(
                          'markdownEditor',
                        )
                      ) {
                        onClick_EditMarkdownBtn();
                      } else if (
                        resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes(
                          'cartoonEditor',
                        )
                      ) {
                        dispatch<OnClick_OpenCartoonBtn_Action>({
                          type: 'resourceVersionCreatorPage/onClick_OpenCartoonBtn',
                        });
                      }
                    }}
                  >
                    <FIcons.FEdit style={{ fontSize: 14, color: 'inherit' }} />
                    <span>
                      {
                        // 编辑
                        FI18n.i18nNext.tAuto('create_new_version_edit')
                      }
                    </span>
                  </FTextBtn>
                )}

                {resourceVersionCreatorPage.resourceTypeConfig.isSupportDownload && (
                  <FTextBtn
                    type='primary'
                    size='default'
                    disabled={resourceVersionCreatorPage.systemPropertiesState === 'parsing'}
                    onClick={() => {
                      if (!resourceVersionCreatorPage.selectedFileInfo) {
                        return;
                      }
                      self.location.href =
                        FUtil.Format.completeUrlByDomain('api') +
                        `/v2/storages/files/${
                          resourceVersionCreatorPage.selectedFileInfo?.sha1 || ''
                        }/download?attachmentName=${
                          resourceVersionCreatorPage.selectedFileInfo?.name || 'download'
                        }`;
                    }}
                  >
                    <FIcons.FDownload style={{ fontSize: 14, color: 'inherit' }} />
                    <span>
                      {
                        // 下载
                        FI18n.i18nNext.tAuto('edit_resource_vmgnt_btn_download')
                      }
                    </span>
                  </FTextBtn>
                )}

                <FTextBtn
                  type='danger'
                  size='default'
                  disabled={resourceVersionCreatorPage.systemPropertiesState === 'parsing'}
                  onClick={() => {
                    dispatch<OnDelete_ObjectFile_Action>({
                      type: 'resourceVersionCreatorPage/onDelete_ObjectFile',
                    });
                  }}
                >
                  <FIcons.FDelete style={{ fontSize: 14, color: 'inherit' }} />
                  <span>
                    {
                      // 移除（删除所选文件）
                      FI18n.i18nNext.tAuto('remove')
                    }
                  </span>
                </FTextBtn>
              </div>
            </div>

            {isVideoResource && (
              <div className={styles.videoCoverRow}>
                <FUploadCover
                  use={'resource'}
                  onUploadSuccess={(url) => {
                    dispatch<ChangeAction>({
                      type: 'resourceVersionCreatorPage/change',
                      payload: {
                        videoCover: url,
                        dataIsDirty: true,
                      },
                    });
                  }}
                >
                  <span className={styles.videoCoverBtn}>
                    {resourceVersionCreatorPage.videoCover ? '更换视频封面' : '上传视频封面'}
                  </span>
                </FUploadCover>
              </div>
            )}
          </div>

          <div style={{ height: 5 }} />

          {/* {resourceVersionCreatorPage.systemPropertiesState === 'parsing' && (
            <>
              <div style={{ height: 20 }} />
              <FSkeletonNode width={920} height={38} />
              <div style={{ height: 20 }} />
              <FSkeletonNode width={340} height={38} />
            </>
          )} */}

          {/* {resourceVersionCreatorPage.systemPropertiesState === 'success' && (
            <> */}
          <div className={styles.block} style={{ position: 'relative' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                text={
                  // 基础属性
                  FI18n.i18nNext.tAuto('resourceinfo_title')
                }
                type={'highlight'}
              />
              {resourceVersionCreatorPage.customProperties.length < 30 && (
                <Space size={10}>
                  <FTooltip title={FI18n.i18nNext.tAuto('resourceinfo_add_btn_info')}>
                    <div>
                      <FComponentsLib.FTextBtn
                        style={{
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                        type='primary'
                        onClick={async () => {
                          const dataSource: {
                            key: string;
                            name: string;
                            description: string;
                          } | null = await fResourcePropertyEditor3({
                            disabledKeys: [
                              ...resourceVersionCreatorPage.systemProperties.map<string>(
                                (rp) => rp.key,
                              ),
                              ...resourceVersionCreatorPage.customProperties.map<string>(
                                (bp) => bp.key,
                              ),
                              ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                (pp) => pp.key,
                              ),
                            ],
                            disabledNames: [
                              ...resourceVersionCreatorPage.systemProperties.map<string>(
                                (rp) => rp.name,
                              ),
                              ...resourceVersionCreatorPage.customProperties.map<string>(
                                (bp) => bp.name,
                              ),
                              ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                (pp) => pp.name,
                              ),
                            ],
                          });
                          if (!dataSource) {
                            return;
                          }

                          await dispatch<OnChange_CustomProperties_Action>({
                            type: 'resourceVersionCreatorPage/onChange_CustomProperties',
                            payload: {
                              value: [
                                ...resourceVersionCreatorPage.customProperties,
                                { ...dataSource, value: '' },
                              ],
                            },
                          });
                        }}
                      >
                        <FIcons.FProperty style={{ fontSize: 14 }} />
                        <span>
                          {
                            // 补充属性
                            FI18n.i18nNext.tAuto('resourceinfo_add_title')
                          }
                        </span>
                      </FComponentsLib.FTextBtn>
                    </div>
                  </FTooltip>
                </Space>
              )}
            </div>

            {[
              ...resourceVersionCreatorPage.systemProperties.filter((rp) => {
                return !(rp.type === 'raw' && rp.value === '');
              }),
              ...resourceVersionCreatorPage.customProperties,
            ].length === 0 && (
              <>
                <div style={{ height: 10 }} />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.tAuto('resourceinfo_empty_msg')}
                    type={'additional2'}
                    style={{ maxWidth: 600, textAlign: 'center' }}
                  />
                </div>
              </>
            )}

            {[
              ...resourceVersionCreatorPage.systemProperties.filter((rp) => {
                return !(rp.type === 'raw' && rp.value === '');
              }),
              ...resourceVersionCreatorPage.customProperties,
            ].length > 0 && (
              <>
                <div style={{ height: 20 }} />
                <FAttrsAndConfigs
                  dateSource={[
                    ...resourceVersionCreatorPage.systemProperties.map<IAttrsAndConfigsItem>(
                      (sp) => {
                        return {
                          key: sp.key,
                          value: sp.value,
                          name: sp.name,
                          description: sp.description,
                          configs: {
                            item_Deletable: false,
                            key_Editable: false,
                            name_Editable: false,
                            description_Editable: false,
                            value_Editable: (sp.type === 'additional' && sp.valueConfig) || false,
                          },
                        };
                      },
                    ),
                    ...resourceVersionCreatorPage.customProperties.map<IAttrsAndConfigsItem>(
                      (cp) => {
                        return {
                          key: cp.key,
                          value: cp.value,
                          name: cp.name,
                          description: cp.description,
                          configs: {
                            item_Deletable: true,
                            key_Editable: true,
                            name_Editable: true,
                            description_Editable: true,
                            value_Editable: {
                              text: {
                                nullable: true,
                                minLength: 0,
                                maxLength: 140,
                              },
                            },
                          },
                        };
                      },
                    ),
                  ]}
                  onChangeItem={(oldData, newData, index) => {
                    if (index < resourceVersionCreatorPage.systemProperties.length) {
                      const newDateSource = [...resourceVersionCreatorPage.systemProperties];
                      newDateSource[index] = {
                        key: newData.key,
                        name: newData.name,
                        value: newData.value,
                        description: newData.description,
                        type: resourceVersionCreatorPage.systemProperties[index].type,
                        valueConfig: resourceVersionCreatorPage.systemProperties[index].valueConfig,
                      };

                      dispatch<ChangeAction>({
                        type: 'resourceVersionCreatorPage/change',
                        payload: {
                          systemProperties: newDateSource,
                          dataIsDirty: true,
                        },
                      });
                    } else {
                      const newDateSource = [...resourceVersionCreatorPage.customProperties];
                      newDateSource[index - resourceVersionCreatorPage.systemProperties.length] = {
                        key: newData.key,
                        name: newData.name,
                        value: newData.value,
                        description: newData.description,
                      };
                      dispatch<OnChange_CustomProperties_Action>({
                        type: 'resourceVersionCreatorPage/onChange_CustomProperties',
                        payload: {
                          value: newDateSource,
                        },
                      });
                    }
                  }}
                  onDeleteItem={(value) => {
                    dispatch<OnChange_CustomProperties_Action>({
                      type: 'resourceVersionCreatorPage/onChange_CustomProperties',
                      payload: {
                        value: resourceVersionCreatorPage.customProperties.filter((cp) => {
                          return cp.key !== value.key && cp.name !== value.name;
                        }),
                      },
                    });
                  }}
                  disabledKeys={[
                    ...resourceVersionCreatorPage.systemProperties.map<string>((rp) => rp.key),
                    ...resourceVersionCreatorPage.customProperties.map<string>((cp) => cp.key),
                    ...resourceVersionCreatorPage.customConfigurations.map<string>((cp) => cp.key),
                  ]}
                  disabledNames={[
                    ...resourceVersionCreatorPage.systemProperties.map<string>((rp) => rp.name),
                    ...resourceVersionCreatorPage.customProperties.map<string>((cp) => cp.name),
                    ...resourceVersionCreatorPage.customConfigurations.map<string>((cp) => cp.name),
                  ]}
                />
              </>
            )}

            {resourceVersionCreatorPage.systemPropertiesState === 'parsing' && (
              <div className={styles.parsingTip}>
                <FIcons.FLoading style={{ fontSize: 14, color: '#E9A923' }} />
                <span>{FI18n.i18nNext.tAuto('creatversion_property_msg_backendprocessing')}</span>
              </div>
            )}
          </div>

          <div style={{ height: 15 }} />

          {$showMore ? (
            <FComponentsLib.FTextBtn
              style={{ fontSize: 12 }}
              type={'primary'}
              onClick={() => {
                set$ShowMore(false);
              }}
            >
              {FI18n.i18nNext.tAuto('create_new_version_btn_showless')}
            </FComponentsLib.FTextBtn>
          ) : (
            <Space size={10}>
              <FComponentsLib.FTextBtn
                style={{ fontSize: 12 }}
                type={'primary'}
                onClick={() => {
                  set$ShowMore(true);
                }}
              >
                {/* 更多设置 */}
                {FI18n.i18nNext.tAuto('create_new_version_btn_moresetting')}
              </FComponentsLib.FTextBtn>
              <FComponentsLib.FContentText
                text={FI18n.i18nNext.tAuto('create_new_version_btn_moresetting_help')}
                type={'additional2'}
              />
            </Space>
          )}
          {/* </>
          )} */}

          <div style={{ display: $showMore ? 'block' : 'none' }}>
            <div style={{ height: 10 }} />
            {resourceVersionCreatorPage.resourceTypeConfig.isSupportOptionalConfig && (
              <>
                <div className={styles.block}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FComponentsLib.FContentText
                      text={FI18n.i18nNext.tAuto('resourceoptions_title')}
                      type={'highlight'}
                    />

                    {resourceVersionCreatorPage.customConfigurations.length < 30 && (
                      <Space size={10}>
                        <FTooltip title={FI18n.i18nNext.tAuto('info_versionoptions')}>
                          <div>
                            <FComponentsLib.FTextBtn
                              style={{
                                fontSize: 12,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5,
                              }}
                              type='primary'
                              onClick={async () => {
                                const dataSource: {
                                  key: string;
                                  name: string;
                                  type: 'input' | 'select';
                                  input: string;
                                  select: string[];
                                  description: string;
                                } | null = await fResourceOptionEditor({
                                  disabledKeys: [
                                    ...resourceVersionCreatorPage.systemProperties.map<string>(
                                      (rp) => rp.key,
                                    ),
                                    ...resourceVersionCreatorPage.customProperties.map<string>(
                                      (bp) => bp.key,
                                    ),
                                    ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                      (pp) => pp.key,
                                    ),
                                  ],
                                  disabledNames: [
                                    ...resourceVersionCreatorPage.systemProperties.map<string>(
                                      (rp) => rp.name,
                                    ),
                                    ...resourceVersionCreatorPage.customProperties.map<string>(
                                      (bp) => bp.name,
                                    ),
                                    ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                      (pp) => pp.name,
                                    ),
                                  ],
                                });

                                if (!dataSource) {
                                  return;
                                }

                                await dispatch<OnChange_CustomConfigurations_Action>({
                                  type: 'resourceVersionCreatorPage/onChange_CustomConfigurations',
                                  payload: {
                                    value: [
                                      ...resourceVersionCreatorPage.customConfigurations,
                                      dataSource,
                                    ],
                                  },
                                });
                              }}
                            >
                              <FIcons.FConfiguration style={{ fontSize: 14 }} />
                              <span>{FI18n.i18nNext.tAuto('resourceoptions_add_btn')}</span>
                            </FComponentsLib.FTextBtn>
                          </div>
                        </FTooltip>
                      </Space>
                    )}
                  </div>

                  {resourceVersionCreatorPage.customConfigurations.length === 0 && (
                    <>
                      <div style={{ height: 10 }} />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FComponentsLib.FContentText
                          text={FI18n.i18nNext.tAuto('resourceoptions_list_empty')}
                          type={'additional2'}
                        />
                      </div>
                      <div style={{ height: 20 }} />
                    </>
                  )}

                  {resourceVersionCreatorPage.customConfigurations.length > 0 && (
                    <>
                      <div style={{ height: 20 }} />
                      <FResourceOptions
                        theme={'dark'}
                        dataSource={resourceVersionCreatorPage.customConfigurations}
                        onEdit={async (value) => {
                          const index: number =
                            resourceVersionCreatorPage.customConfigurations.findIndex((p) => {
                              return p === value;
                            });

                          const dataSource: {
                            key: string;
                            name: string;
                            type: 'input' | 'select';
                            input: string;
                            select: string[];
                            description: string;
                          } | null = await fResourceOptionEditor({
                            disabledKeys: [
                              ...resourceVersionCreatorPage.systemProperties.map<string>(
                                (rp) => rp.key,
                              ),
                              ...resourceVersionCreatorPage.customProperties.map<string>(
                                (bp) => bp.key,
                              ),
                              ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                (pp) => pp.key,
                              ),
                            ],
                            disabledNames: [
                              ...resourceVersionCreatorPage.systemProperties.map<string>(
                                (rp) => rp.name,
                                ``,
                              ),
                              ...resourceVersionCreatorPage.customProperties.map<string>(
                                (bp) => bp.name,
                              ),
                              ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                (pp) => pp.name,
                              ),
                            ],
                            defaultData: value,
                          });

                          if (!dataSource) {
                            return;
                          }

                          await dispatch<OnChange_CustomConfigurations_Action>({
                            type: 'resourceVersionCreatorPage/onChange_CustomConfigurations',
                            payload: {
                              value: resourceVersionCreatorPage.customConfigurations.map((a, b) => {
                                if (b !== index) {
                                  return a;
                                }
                                return dataSource;
                              }),
                            },
                          });
                        }}
                        onDelete={async (value) => {
                          await dispatch<OnChange_CustomConfigurations_Action>({
                            type: 'resourceVersionCreatorPage/onChange_CustomConfigurations',
                            payload: {
                              value: resourceVersionCreatorPage.customConfigurations.filter((a) => {
                                return a.key !== value.key && a.name !== value.name;
                              }),
                            },
                          });
                        }}
                      />
                    </>
                  )}
                </div>

                <div style={{ height: 5 }} />
              </>
            )}

            <div className={styles.block}>
              {resourceVersionCreatorPage.resourceInfo &&
                resourceVersionCreatorPage.authReload > 0 && (
                  <FMicroAPP_Authorization
                    licenseeId={resourceVersionCreatorPage.resourceInfo.resourceID}
                    licenseeVersion={resourceVersionCreatorPage.versionInput}
                    mainAppType={'resourceInVersionUpdate'}
                    depList={resourceVersionCreatorPage.directDependencies}
                    upcastList={resourceVersionCreatorPage.baseUpcastResources}
                    mount={(data) => {
                      set$ShowMore(get$ShowMore() || (data.directDependencies || []).length > 0);
                      dispatch<ChangeAction>({
                        type: 'resourceVersionCreatorPage/change',
                        payload: {
                          directDependencies: data.directDependencies || [],
                          baseUpcastResources: data.baseUpcastResources || [],
                          isCompleteAuthorization: data.isAllAuthComplete || false,
                          authExcludedItems: data.authExcludedItems || [],
                        },
                      });
                    }}
                    update={(data) => {
                      set$ShowMore(get$ShowMore() || (data.directDependencies || []).length > 0);
                      dispatch<ChangeAction>({
                        type: 'resourceVersionCreatorPage/change',
                        payload: {
                          directDependencies: data.directDependencies || [],
                          baseUpcastResources: data.baseUpcastResources || [],
                          isCompleteAuthorization: data.isAllAuthComplete || false,
                          dataIsDirty: true,
                          authExcludedItems: data.authExcludedItems || [],
                        },
                      });
                    }}
                  />
                )}
            </div>
          </div>

          <div style={{ height: 10 }} />

          <VersionDescriptionEditor
            value={resourceVersionCreatorPage.descriptionText}
            onChange={(value) => {
              dispatch<OnChange_DescriptionText_Action>({
                type: 'resourceVersionCreatorPage/onChange_DescriptionText',
                payload: {
                  value: value,
                },
              });
            }}
          />
          <div style={{ height: 30 }} />

          <div className={styles.btn}>
            {resourceVersionCreatorPage.draftSaveTime && (
              <FComponentsLib.FContentText
                text={`已保存 ${resourceVersionCreatorPage.draftSaveTime}`}
                type={'additional2'}
              />
            )}

            <FComponentsLib.FTextBtn
              type={'default'}
              onClick={() => {
                dispatch<OnTrigger_SaveDraft_Action>({
                  type: 'resourceVersionCreatorPage/onTrigger_SaveDraft',
                  payload: {
                    showSuccessTip: true,
                  },
                });
              }}
            >
              {FI18n.i18nNext.tAuto('save_as_draft')}
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FRectBtn
              disabled={hasError}
              type={'primary'}
              onClick={() => {
                dispatch<OnClick_CreateVersionBtn_Action>({
                  type: 'resourceVersionCreatorPage/onClick_CreateVersionBtn',
                });
              }}
            >
              {FI18n.i18nNext.tAuto('release_to_market')}
            </FComponentsLib.FRectBtn>
          </div>

          <div style={{ height: 100 }} />
        </div>
      </div>

      <FMicroApp_MarkdownEditorDrawer
        open={resourceVersionCreatorPage.isOpenMarkdown}
        resourceID={resourceVersionCreatorPage.resourceInfo?.resourceID || ''}
        onChange_Saved={(saved) => {
          dispatch<ChangeAction>({
            type: 'resourceVersionCreatorPage/change',
            payload: {
              isDirtyMarkdownEditor: !saved,
            },
          });
        }}
        onClose={() => {
          onClose_EditMarkdown();
        }}
      />
      <FMicroApp_CartoonEditorDrawer
        open={resourceVersionCreatorPage.isOpenCartoon}
        resourceID={resourceVersionCreatorPage.resourceInfo?.resourceID || ''}
        onChange_Saved={(saved) => {
          // console.log(saved, 'saved sdifj;sldkjflkj');
          dispatch<ChangeAction>({
            type: 'resourceVersionCreatorPage/change',
            payload: {
              isDirtyCartoonEditor: !saved,
            },
          });
        }}
        onClose={() => {
          dispatch<OnClose_CartoonEditor_Action>({
            type: 'resourceVersionCreatorPage/onClose_CartoonEditor',
          });
        }}
      />
    </>
  );
}

export default connect(({ resourceVersionCreatorPage }: ConnectState) => ({
  resourceVersionCreatorPage: resourceVersionCreatorPage,
}))(VersionCreator);
